import { Button, styled, Typography } from '@mui/material';
import React from 'react';
import somethingWentWrongUrl from '../../../../../../../assets/image/SomethingWentWrong.png';
import { useLocalStorageExecutorRoleServiceContext } from '../../../../context/contexts';
import { GraphQLError } from '../../../errors';
import { Error } from './Error';
import ErrorTechnicalDetails from './ErrorTechnicalDetails';

const StyledButton = styled(Button)`
  background-color: #00a599;
  &:hover {
    background-color: rgba(27, 113, 107);
  }
`;

interface SomethingWentWrongErrorProps {
  error: Error;
}

const SomethingWentWrongError = (props: SomethingWentWrongErrorProps) => {
  const localStorageExecutorRoleService =
    useLocalStorageExecutorRoleServiceContext();
  const { error } = props;
  const graphQlError = error instanceof GraphQLError ? error : null;

  return (
    <Error
      image={
        <img
          src={somethingWentWrongUrl}
          width={'100%'}
          height={'100%'}
          style={{ objectFit: 'contain' }}
        />
      }
      title={{ key: 'pages:errorBoundary.caution' }}
      message={(t) => (
        <>
          <Typography variant="h5">
            {t('pages:errorBoundary.message')}
          </Typography>
          <ErrorTechnicalDetails
            errorCode={graphQlError?.errorCode ?? null}
            errorReference={graphQlError?.errorReference ?? null}
          />
        </>
      )}
      exit={(t) => {
        const redirectToHome = () => {
          localStorageExecutorRoleService.clear();
          window.location.pathname = '/';
        };
        return (
          <StyledButton
            variant="contained"
            color="primary"
            onClick={redirectToHome}
          >
            {t('pages:errorBoundary.goToHome')}
          </StyledButton>
        );
      }}
    />
  );
};

export default SomethingWentWrongError;
